/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateDeliveryOriginDto
 */
export interface UpdateDeliveryOriginDto {
    /**
     * Origin name
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof UpdateDeliveryOriginDto
     */
    'originSourceApi'?: UpdateDeliveryOriginDtoOriginSourceApiEnum;
}

export const UpdateDeliveryOriginDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type UpdateDeliveryOriginDtoOriginSourceApiEnum = typeof UpdateDeliveryOriginDtoOriginSourceApiEnum[keyof typeof UpdateDeliveryOriginDtoOriginSourceApiEnum];


